import React from 'react';

export const StarsAndStripesHeader = ({ height = 8 }) => (
    <div style={{
        width: '100%',
        height: `${height}px`,
        background: `repeating-linear-gradient(
            90deg,
            #BF0A30 0px,
            #BF0A30 20px,
            #FFFFFF 20px,
            #FFFFFF 40px
        )`,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }} />
);

export const PatrioticBorder = ({ children, style = {} }) => (
    <div style={{
        position: 'relative',
        padding: '3px',
        background: `linear-gradient(90deg, #BF0A30, #FFFFFF, #002868)`,
        borderRadius: '8px',
        ...style
    }}>
        <div style={{
            background: '#FFFFFF',
            borderRadius: '5px',
            padding: '16px'
        }}>
            {children}
        </div>
    </div>
);

export const StarPattern = ({ count = 5, size = 12, color = '#002868' }) => (
    <div style={{ display: 'flex', gap: '4px' }}>
        {[...Array(count)].map((_, i) => (
            <svg
                key={i}
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill={color}
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M12 2L14.09 8.26L20.71 9.27L16.36 13.52L17.53 20.13L12 16.89L6.47 20.13L7.64 13.52L3.29 9.27L9.91 8.26L12 2Z" />
            </svg>
        ))}
    </div>
);

export const PatrioticButton = ({ 
    children, 
    onClick, 
    variant = 'primary', 
    style = {},
    ...props 
}) => {
    const getButtonStyle = () => {
        switch(variant) {
            case 'primary':
                return {
                    background: '#002868',
                    color: '#FFFFFF',
                    border: '2px solid #002868'
                };
            case 'secondary':
                return {
                    background: '#BF0A30',
                    color: '#FFFFFF',
                    border: '2px solid #BF0A30'
                };
            case 'outline':
                return {
                    background: 'transparent',
                    color: '#002868',
                    border: '2px solid #002868'
                };
            default:
                return {
                    background: '#002868',
                    color: '#FFFFFF',
                    border: '2px solid #002868'
                };
        }
    };

    return (
        <button
            onClick={onClick}
            style={{
                padding: '8px 16px',
                borderRadius: '4px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                ...getButtonStyle(),
                ...style
            }}
            onMouseEnter={(e) => {
                e.target.style.opacity = '0.9';
                e.target.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
                e.target.style.opacity = '1';
                e.target.style.transform = 'translateY(0)';
            }}
            {...props}
        >
            {children}
        </button>
    );
};

const PatrioticComponents = {
    StarsAndStripesHeader,
    PatrioticBorder,
    StarPattern,
    PatrioticButton
};

export default PatrioticComponents;